import { inter } from "../fonts/inter";
import { motion } from "framer-motion";
import HeroBackground from "../components/background/HeroBackground";
import React from "react";
import AnimatedTitle from "../animations/AnimatedTitle";
import Image from "next/image";

const Hero = () => {
  return (
    <motion.section
      className="relative z-10 flex h-[100vh] w-full justify-center"
      id="home"
      initial="initial"
      animate="animate"
    >
      <HeroBackground />
      <div className="mt-10 flex flex-col items-center justify-center sm:mt-0">
        <div
          className={`relative flex flex-col items-center justify-center ${inter.className} pointer-events-none`}
        >
          <div className="flex items-start gap-4">
            <AnimatedTitle
              text={"Hi, I'm Mike."}
              className={
                "mb-1 text-left text-[40px] font-bold leading-[0.9em] tracking-tighter text-[#e4ded7] sm:text-[45px] md:mb-16 md:text-[60px] lg:text-[80px]"
              }
              wordSpace={"mr-[10px]"}
              charSpace={"mr-[0.001em]"}
            />
            <Image
              src="https://pbs.twimg.com/profile_images/1837114580641710080/zztwyLlV_400x400.jpg"
              alt="Mike R."
              width={80}
              height={80}
              className="pointer-events-auto rounded-full"
            />
          </div>

          <div className="mt-8 flex flex-col items-center gap-4 sm:mt-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="pointer-events-auto"
            >
              <a
                href="https://docs.google.com/document/d/1Fc_85D_sb6udmWAqiUf81R1eWfoU21lFbP3hed3jArw/edit?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-3 rounded-full bg-gradient-to-r from-green-600 to-teal-600 px-8 py-3 text-white shadow-lg transition-all duration-300 hover:scale-105 hover:from-green-700 hover:to-teal-700 hover:shadow-xl"
              >
                <span className="text-sm font-medium">📄</span>
                <span className="text-lg font-bold">View My CV</span>
                <span className="text-xl transition-transform duration-300 group-hover:translate-x-1">
                  →
                </span>
              </a>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Hero;
